import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';
import { BehaviorSubject, Observable, of } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  first,
  map,
  take,
} from 'rxjs/operators';
import { CheckContentPackNameResponse } from '../../models/content-packs';
import { PacksService } from '../packs.service';

export function validateContentPackName(
  packsService: PacksService,
  loading$: BehaviorSubject<boolean>,
  currentName: string,
): AsyncValidatorFn {
  return (
    control: AbstractControl,
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
    if (
      (control.value === currentName && currentName !== '') ||
      control.value.length > 50 ||
      control.value.length < 3
    ) {
      return of(null).pipe(take(1));
    } else {
      loading$.next(true);
      return packsService.checkContentPackName(control.value).pipe(
        debounceTime(500),
        distinctUntilChanged(),
        take(1),
        map((res: CheckContentPackNameResponse) => {
          loading$.next(false);
          if (res.nameExists) {
            return { nameExists: true };
          } else if (res.result !== 'SUCCESS') {
            // Only occurs when service encounters an error
            return { serverNotConnected: true };
          } else {
            return null;
          }
        }),
        first(),
      );
    }
  };
}
